import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import _ from 'lodash';
import './stylesheets/Form.css';

import { MergeAttributes } from '../FlatData';

class Form extends Component {
  constructor(){
    super();

    this.state = {
      id: null,
      selected: [],
      name: "",
      can_receive_outer: false,
      central: false,
      is_secretary: false,
      is_correspondence: true
    }

    this.onRowSelect = this.onRowSelect.bind(this);
    this.removeSelected = this.removeSelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setGroupName = this.setGroupName.bind(this);
    this.createCustomToolBar = this.createCustomToolBar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCentral = this.handleChangeCentral.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let nextDepartmentGroup = nextProps.departmentGroup;
    if (nextDepartmentGroup.id && this.props.id !== nextDepartmentGroup.id) {
      let selected = nextDepartmentGroup.positions_users.map(pu => pu.id);

      this.setState({
        id: nextDepartmentGroup.id,
        selected: selected,
        name: nextDepartmentGroup.name,
        can_receive_outer: nextDepartmentGroup.can_receive_outer,
        central: nextDepartmentGroup.central,
        is_secretary: nextDepartmentGroup.is_secretary,
        is_correspondence: nextDepartmentGroup.is_correspondence
      });
    } else {
      this.setState({
        id: null,
        selected: [],
        name: "",
        can_receive_outer: false,
        central: false,
        is_secretary: false,
        is_correspondence: true
      })
    }
  }

  onRowSelect(row, isSelected, e) {
    let selected = _.clone(this.state.selected)
    let isIncluded = _.includes(selected, row.id)

    if (isIncluded){
      selected = _.pull(selected, row.id)
    }else{
      selected = [...selected, row.id]
    }
    
    this.setState({selected: selected})
  }

  removeSelected(PositionUserId){
    this.setState({
      selected: _.pull(this.state.selected, PositionUserId)
    });
  }

  setGroupName(event){
    this.setState({ name: event.target.value });
  }

  handleSubmit(){
    if (!this.state.is_secretary && !this.state.is_correspondence && !this.state.central){
      alert('กรุณาเลือกประเภท เลขา, สารบรรณ หรือ สารบรรณกองกลาง');
      return
    }

    this.props.onSubmit({
      id: this.state.id,
      positions_user_ids: this.state.selected,
      name: this.state.name,
      can_receive_outer: this.state.can_receive_outer,
      central: this.state.central,
      is_secretary: this.state.is_secretary,
      is_correspondence: this.state.is_correspondence
    });
  }

  createCustomToolBar(props) {
    return (
      <div className='ml-auto col-6'>
        { props.components.searchPanel }
      </div>
    );
  }

  handleChange(event){
    const name = event.target.name;
    const value = event.target.value;

    if(name === 'is_secretary' && JSON.parse(value) == true){
      this.setState({
        is_correspondence: false,
        can_receive_outer: false,
        central: false,
        [name]: JSON.parse(value)
      })
    } else {
      this.setState({ 
        is_correspondence: true,
        is_secretary: false,
        [name]: JSON.parse(value)
      })
    }
  }

  handleChangeCentral(event){
    this.setState({ central: !this.state.central });
  }

  render(){
    const data = MergeAttributes(this.props.positions_users);
    const selectRowProp = {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: this.onRowSelect,
        selected: this.state.selected
    };
    const options = {
      sizePerPageList: [],
      toolBar: this.createCustomToolBar
    };

    return(
      <div id="department-group-form">
        <div className='card card-body mb-2 bg-light'>
          <div className="row form-group">
            <div className="col-md-2">
              <b>ชื่อกลุ่ม</b>
            </div>
            <div className="col-md-10">
              <input 
                type="text" 
                name="name" 
                className="form-control form-control-sm" 
                value={this.state.name} 
                onChange={this.setGroupName} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-2">
              <b>ประเภท</b>
            </div>

            <div className="col-md-4 col-lg-4">
              <input 
                type='radio' 
                name='can_receive_outer' 
                value='true'
                className='mr-2'
                checked={this.state.is_correspondence && this.state.can_receive_outer == JSON.parse("true")} 
                onChange={this.handleChange}/> 
                สารบรรณสถาบัน สำนัก คณะ
            </div>
            <div className="col-md-4 col-lg-3">
              <input 
                type='radio' 
                name='can_receive_outer' 
                value='false'
                className='mr-2'
                checked={this.state.is_correspondence && this.state.can_receive_outer == JSON.parse("false")} 
                onChange={this.handleChange}/> 
                สารบรรณหน่วยงาน
            </div>
            <div className="col-md-4 col-lg-3">
              <input 
                type='checkbox' 
                name='central' 
                className='mr-2'
                checked={this.state.central} 
                onChange={this.handleChangeCentral}/> 
                สารบรรณกองกลาง
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">

            </div>

            <div className="col-md-4 col-lg-2">
              <input 
                type='radio' 
                name='is_secretary' 
                value='true'
                checked={this.state.is_secretary} 
                className='mr-2' 
                onChange={this.handleChange}/> 
                เลขา
            </div>
          </div>

        </div>
        <div className="row">
          <div className="col-md-7 rui-dp">
            <BootstrapTable 
              data={data}
              search={ true }
              multiColumnSearch={ true }
              selectRow={ selectRowProp }
              options={ options }
              striped
              hover
              condensed
              pagination
              version='4'
              tableContainerClass={'table-sm'}>
                <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
                <TableHeaderColumn dataField='full_name' columnTitle dataSort={ true }>ชื่อ - นามสกุล</TableHeaderColumn>
                <TableHeaderColumn dataField='position_name' columnTitle dataSort={ true }>ตำแหน่ง</TableHeaderColumn>
                <TableHeaderColumn dataField='group_name' columnTitle dataSort={ true }>แผนก</TableHeaderColumn>
            </BootstrapTable>
          </div>
          <div className="col-md-5 pl-md-0 mb-3">
            <h4>บุคคลที่ถูกเลือก {`(${this.state.selected.length})`}</h4>
            <div className={`${this.state.selected.length > 0 && "card"}`}>
              <ul id="selected-users" className="list-group list-group-flush">
                {this.state.selected.map(PositionUserId => {
                  let position_user = _.find(this.props.positions_users, {id: PositionUserId});
                  return(
                    <li className="list-group-item" key={PositionUserId}>
                      {position_user.full_name}
                      <br />
                      {`${position_user.position_name} - ${position_user.group_name}`}
                      <i className='fa fa-times close-icon text-danger' onClick={() => this.removeSelected(PositionUserId)}></i>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="modal-footer row">
          <button type='button' className="btn btn-primary pointer" onClick={this.handleSubmit}>บันทึกข้อมูล</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.props.onClose}>ยกเลิก</button>
        </div>
      </div>
    )
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/DepartmentGroup/Form.js